<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('roles.add') }}</h1>
          <hr />
          <role-form />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import RoleForm from '@/components/roles/RoleForm.vue';
import hasPermission from '@/helpers/hasPermission';

export default {
  beforeRouteEnter(to, from, next) {
    if (hasPermission('role_add')) next();
    if (from.name !== 'roles-list') next({ name: 'roles-list' });
  },
  components: { RoleForm },
};
</script>

<style></style>
